import {
  SEND_MESSAGE,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_ERROR,
  SET_LAST_MESSAGE,
  SET_MESSAGES,
  SET_LIMIT_REACHED,
  SET_LIMIT_MESSAGE,
  SET_BUSY_MESSAGE,
  CLEAN_MESSAGES_STORE,
  SET_RETRY_SEND_MSG_COUNT,
  SET_RETRY_LOAD_MSG_COUNT,
} from './constants';

const INITIAL_STATE = {
  messages: [],
  lastMessage: '',
  limitReached: false,
  allMessagesLoaded: false,
  busyMessage: '',
  limitMessage: '',
  loading: false,
  error: null,
  retrySendMsgCount: 0,
  retryLoadMsgCount: 0,
};

const messagesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SEND_MESSAGE:
      return {
        ...state,
        loading: true,
      };
    case SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case SEND_MESSAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SET_MESSAGES:
      // const messages = state.messages;
      return {
        ...state,
        loading: false,
        error: null,
        messages: action.payload,
        scrollToBottom: true,
      };
    case SET_LAST_MESSAGE:
      return {
        ...state,
        lastMessage: action.payload,
      };
    case SET_LIMIT_REACHED:
      return {
        ...state,
        limitReached: true,
      };
    case SET_LIMIT_MESSAGE:
      return {
        ...state,
        limitMessage: action.payload,
      };
    case SET_BUSY_MESSAGE:
      return {
        ...state,
        busyMessage: action.payload,
      };
    case SET_RETRY_SEND_MSG_COUNT:
      return {
        ...state,
        retrySendMsgCount: action.payload,
      };
    case SET_RETRY_LOAD_MSG_COUNT:
      return {
        ...state,
        retryLoadMsgCount: action.payload,
      };
    case CLEAN_MESSAGES_STORE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default messagesReducer;
